<script>
import moment from 'moment'
import StatisticService from '@/services/statistic.service'
import TopActiveBase from '@/views/Analytics/General/TopActiveBase'

export default {
    name: 'TopActiveUsers',
    extends: TopActiveBase,
    computed: {
        title () {
            return this.$t('topApiCallByUser')
        },
        sheetName () {
            return this.$t('user')
        },
        headers () {
            return this.$appService.correctHeaders([
                {
                    text: this.$t('email'),
                    value: 'key'
                },
                {
                    text: this.$t('request'),
                    value: 'doc_count'
                }
            ])
        }
    },
    methods: {
        update () {
            StatisticService.getActiveUserStatistic(
                moment(this.fromDate).valueOf(),
                moment(this.toDate).endOf('day').valueOf(),
                this.max
            ).then(
                result => {
                    this.dataTable = result.data
                }
            )
        }
    }
}
</script>
